import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
export var positions = {
  ABSOLUTE: 'absolute',
  FIXED: 'fixed',
  RELATIVE: 'relative',
  STICKY: 'sticky'
};
positions.ALL = _Object$values(positions);
export var placements = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  CENTER: 'center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right'
};
placements.ALL = _Object$values(placements);
//# sourceMappingURL=box.js.map